import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

import {
    HelpPlacingOrderFormModel,
    HelpPlacingOrderFormParamter,
    helpPlacingOrderFormService,
} from "@tCentro/Services/CENHelpPlacingOrderFormService";

type HandlerType = ApiHandler<
    HelpPlacingOrderFormParamter & HasOnSuccess<HelpPlacingOrderFormModel>,
    HelpPlacingOrderFormModel
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await helpPlacingOrderFormService(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const createHelpPlacingOrderForm = createHandlerChainRunner(chain, "createHelpPlacingOrderForm");
export default createHelpPlacingOrderForm;
